import type { SxProps, Theme } from '@mui/material';

export const chartContainer: SxProps<Theme> = {
  px: 3,
  pb: 3,
  pt: 2,
};

export const chartWrapper: SxProps<Theme> = {
  height: '500px',
  width: '100%',
};

export const loadingContainer: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '500px',
};

export const errorContainer: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '500px',
};

